import { render, staticRenderFns } from "./fccOutrasFases.vue?vue&type=template&id=3f292ac6"
import script from "./fccOutrasFases.vue?vue&type=script&lang=js"
export * from "./fccOutrasFases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports